import classNames from 'clsx';
import React, { memo, useCallback } from 'react';
import { multiTariffHighlightWebview } from 'reactApp/appHelpers/featuresHelpers/features/multiTariffMobile';
import { renderFeaturesListMobileModal } from 'reactApp/sections/MobileQuotaTariffsLanding/FeaturesModal/FeaturesModal.helpers';
import type { MobileBuyClickType } from 'reactApp/sections/MobileSubscriptionsPage/TariffCard/TariffCard.types';
import { FeatureIDs } from 'reactApp/sections/QuotaLanding/MultiTariffsListMobile/Features/Features.types';
import { useFeaturesList } from 'reactApp/sections/QuotaLanding/MultiTariffsListMobile/Features/hooks/useFeaturesList';
import { sendQuotaGa } from 'reactApp/sections/QuotaLanding/QuotaLanding.helpers';
import type { Product } from 'reactApp/types/Billing';
import { openUnlimitedUploadInfo } from 'reactApp/ui/Mobile/UnlimitedUploadInfo/UnlimitedUploadInfo.helpers';
import { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';

import styles from './Features.css';

interface FeaturesProps {
    space: number;
    product?: Product;
    onBuyClick: MobileBuyClickType;
    activeTariffTab?: ETabsName;
}

export const Features = memo<FeaturesProps>(({ space, product, onBuyClick, activeTariffTab }) => {
    const list = useFeaturesList(space);

    const handleClick = useCallback(
        (id: string) => {
            if (id === FeatureIDs.unlim) {
                sendQuotaGa({
                    action: 'tariff_baz',
                    label: 'click',
                });
                openUnlimitedUploadInfo();
            }

            if (id === FeatureIDs.others) {
                sendQuotaGa({
                    action: 'tariff_benefits',
                    label: 'click',
                    name_button_from: activeTariffTab,
                });
                renderFeaturesListMobileModal({ product, onBuyClick, from: activeTariffTab });
            }
        },
        [product, activeTariffTab, onBuyClick]
    );

    return (
        <div className={styles.root}>
            {list.map(({ id, type, text, iconBefore, iconAfter }) => {
                return (
                    <div
                        key={id + type}
                        className={classNames(styles.item, {
                            [styles[`item-${type}`]]: type,
                            [styles['item-violet']]:
                                multiTariffHighlightWebview && activeTariffTab === ETabsName.family && type === 'highlighted',
                        })}
                        onClick={() => handleClick(id)}
                    >
                        {iconBefore}
                        {text}
                        {iconAfter}
                    </div>
                );
            })}
        </div>
    );
});

Features.displayName = 'Features';
